import React from "react";
import styled from "styled-components";
import Cookies from "js-cookie";
import Theme from "../../Theme";
import { Grid } from "@material-ui/core";
import LocalSideMenu from "./LocalSideMenu";
import ITocItem from "../../models/ITocItem";
import DocBreadcrumb from "./DocBreadcrumb";
import DocHeaderMenu from "./DocHeaderMenu";
import Footer from "../Footer";
import CollapseTab from "../CollapseTab";
import IContentsItem from "../../models/IContentsItem";

const menuOpenCookie = "pp-openDocsMenu";
const drawerWidth = 430;
const minDrawerWidth = 0;
const transitionDuration = 300;
const transitionDelay = 15;

const FlexContainer = styled.div`
  display: flex;
  width: 100%;
`;

const StyledDrawer = styled(Grid)<{ isOpen: boolean }>`
  height: calc(100vh - 105px);
  background-color: ${Theme.colors.lightBackground};
  flex-direction: column;
  flex-shrink: 0;
  white-space: nowrap;
  transition-property: width;
  transition-duration: ${transitionDuration}ms;
  transition-delay: ${transitionDelay}ms;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;

  & .MuiListItem-gutters {
    transition-property: padding-left;
    transition-duration: ${transitionDuration}ms;
    transition-delay: ${transitionDelay}ms;
  }

  ${props =>
    props.isOpen
      ? `
        width: ${drawerWidth}px;
  `
      : `
        width: ${minDrawerWidth}px;
        overflow-x: hidden;

        & .MuiListItem-gutters {
            padding-left: 0px;
        }
  `}

  & .MuiDrawer-paper {
    position: relative;
    background-color: ${Theme.colors.darkBackground};
    color: ${Theme.colors.white};
  }
`;

const MainWrapper = styled.div<{ menuWidth: number }>`
  flex-grow: 1;
  transition-property: padding;
  transition-duration: ${transitionDuration}ms;
  transition-delay: ${transitionDelay}ms;
  min-height: 50vh;

  ${props =>
    `
    padding-left: ${props.menuWidth}px;
  `}
`;

const ContentWrapper = styled.div`
  min-height: calc(100vh - 300px);
  max-width: 1000px;
  flex-grow: 1;
  padding: 0 60px;
`;

const Content = styled.div``;

export interface IDocContext {
  id?: string;
  toc?: ITocItem;
  doc: string;
}

export interface IWithSideMenuProps {
  children: React.ReactNode;
  docContext?: IDocContext;
}

export default function WithSideMenu(props: IWithSideMenuProps) {
  const { children, docContext } = props;
  const menuRef = React.useRef<HTMLDivElement>(null);
  const [open, setOpen] = React.useState(Cookies.get(menuOpenCookie) !== "false");
  const [recheckWidth, setRecheckWidth] = React.useState(0);
  const [tocItems, setTocItems] = React.useState<IContentsItem[] | undefined>();
  const { id, toc, doc } = docContext || {};

  const handleTabClick = () => {
    Cookies.set(menuOpenCookie, open ? "false" : "true");
    setOpen(!open);
  };

  const handleTocLoad = (items: IContentsItem[]) => {
    setRecheckWidth(recheckWidth + 1);
    setTocItems(items);
  };

  let top = 0;
  if (menuRef.current) {
    const rect = menuRef.current.getBoundingClientRect();
    top = rect.top;
  }

  return (
    <FlexContainer>
      <StyledDrawer ref={menuRef} item isOpen={open}>
        <>{id && doc && <LocalSideMenu id={id} toc={toc} contentId={doc} onLoaded={handleTocLoad} />}</>
      </StyledDrawer>
      <CollapseTab
        top={top}
        left={open ? drawerWidth : 0}
        transitionDelay={transitionDelay}
        transitionDuration={transitionDuration}
        open={open}
        onClick={handleTabClick}
      />
      <MainWrapper menuWidth={open ? drawerWidth : 0}>
        {/* <DocHeaderMenu /> */}
        <ContentWrapper>
          {/* <DocBreadcrumb items={tocItems} /> */}
          <Content>{children}</Content>
        </ContentWrapper>
        <Footer />
      </MainWrapper>
    </FlexContainer>
  );
}
